import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 57 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", { fill: "#fc273f" }, [
      _createElementVNode("path", { d: "M48.164 17.302a8.306 8.306 0 1 0 0-16.612 8.306 8.306 0 0 0 0 16.612M28.225 17.302a8.306 8.306 0 1 0 0-16.612 8.306 8.306 0 0 0 0 16.612M8.306 17.302a8.306 8.306 0 1 0 0-16.612 8.306 8.306 0 0 0 0 16.612" })
    ], -1)
  ]))]))
}
export default { render: render }